import styled, { css } from 'styled-components';
import { em } from 'polished';
import { Flex, FlexItem, media } from 'core/layout';
import { HeadingBase } from 'elements/Heading/styled';
import { Button } from 'elements';

export const Section = styled.section`
  margin-top: 1.5rem;

  &:not(:last-of-type) {
    margin-bottom: 3.5em;
  }

  & > *:first-child {
    margin-bottom: 2em;
  }

  ${media.tablet`
    margin-top: 2rem;

    &:not(:last-of-type) {
      margin-bottom: 2em;
    }

    & > *:first-child {
      margin-bottom: 1em;
    }
  `};

  @media print {
    & > div:last-child  > div {
      flex: 0 0 50%;
      max-width: 50%;
      page-break-inside: avoid;
    }
  }
`;

export const SectionHeading = HeadingBase.extend`
  font-size: ${em(24)};

  ${media.tablet`
    font-size: ${em(18)};
  `};
`;

export const CardsWrapper = Flex.extend`
  ${({stretchCards}) => stretchCards && css`
    flex-wrap: wrap;
    align-items: stretch;
  `};
`;

export const HalfFlex = FlexItem.extend`
  flex: 0 0 50%;

  /* IE fix */
  max-width: 50%;

  & > * {
    height: 100%;
  }

  ${media.tabletSmall`
    &:not(:first-child) {
      margin-top: 1em;
    }

    max-width: none;
  `};

  @media print {
    &:not(:first-child) {
      margin-top: 0;
    }
  }
`;

export const ThirdFlex = FlexItem.extend`
  flex: 0 0 ${(1/3) * 100}%;

  /* IE fix */
  max-width: ${(1/3) * 100}%;

  & > * {
    height: 100%;
  }

  ${media.tablet`
    flex: 0 0 50%;

    /* IE fix */
    max-width: 50%;
  `};

  ${media.tabletSmall`
    &:not(:first-child) {
      margin-top: 1em;
    }

    max-width: none;
  `};

  @media print {
    &:not(:first-child) {
      margin-top: 0;
    }
  }
`;

export const SwiperButtonNext = styled(Button)`
  svg {
    width: 2.5rem;
    height: 2.5rem;
  }

  ${media.tablet`
    svg {
      width: 2rem;
      height: 2rem;
    }
  `};
`;

export const SwiperButtonPrev = SwiperButtonNext.extend`
  transform: scaleX(-1) !important;
`;

export const RelatedGroup = styled.div`
    & > div {
      max-width: none;
    }
`;



// WEBPACK FOOTER //
// ./src/pages/Apakskategorija/styled.js